import React, { useEffect } from 'react';
import { FaMapMarkerAlt, FaCalendarAlt, FaUserFriends } from 'react-icons/fa';

// --- CSS STYLES FOR THE BOX INPUT ---
const styles = `
    .search-box-hotel {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 0.75rem 1rem;
        border: 1px solid #dee2e6;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }
    .search-box-hotel:focus-within {
        border-color: var(--primary);
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
    }
    .search-box-hotel .form-label {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }
    .search-box-hotel .form-control {
        border: none;
        padding: 0;
        background-color: transparent;
        font-weight: 500;
        font-size: 1rem;
    }
    .search-box-hotel .form-control:focus {
        box-shadow: none;
    }
`;

// --- Reusable BoxInput Component (defined locally) ---
const BoxInput = ({ icon, label, children }) => (
    <div className="search-box-hotel d-flex align-items-center">
        {icon && <div className="me-3 fs-5 text-muted">{icon}</div>}
        <div className="flex-grow-1">
            <label className="form-label d-block">{label}</label>
            {children}
        </div>
    </div>
);

const HotelSearchPanel2 = () => {
    // Effect to inject the styles into the document head
    useEffect(() => {
        const styleTag = document.createElement('style');
        styleTag.innerHTML = styles;
        document.head.appendChild(styleTag);
        return () => { document.head.removeChild(styleTag); };
    }, []);

    return (
        <div>
            <div className="row g-3">
                {/* Destination Input */}
                <div className="col-lg">
                    <BoxInput label="Destination" icon={<FaMapMarkerAlt />}>
                        <input type="text" className="form-control" placeholder="City, hotel, or landmark" />
                    </BoxInput>
                </div>

                {/* Check-in/Check-out in one box */}
                <div className="col-lg-4">
                    <BoxInput label="Check-in - Check-out" icon={<FaCalendarAlt />}>
                        <div className="d-flex">
                            <input type="date" className="form-control me-2" />
                            <input type="date" className="form-control" />
                        </div>
                    </BoxInput>
                </div>
                
                {/* Guests Input */}
                <div className="col-lg">
                     <BoxInput label="Guests & Rooms" icon={<FaUserFriends />}>
                        <select className="form-select border-0 p-0 bg-transparent">
                            <option>1 Room, 2 Adults</option>
                            <option>1 Room, 1 Adult</option>
                        </select>
                    </BoxInput>
                </div>
                
                {/* Search Button */}
                <div className="col-lg-auto d-grid">
                     <button className="btn btn-primary btn-lg h-100 px-5">Search</button>
                </div>
            </div>
        </div>
    );
};

export default HotelSearchPanel2;